module.exports = __webpack_public_path__ + "img/h-logo.39c7b7f7.svg";